import React, { useEffect, useState } from "react";
import { Form, Button, PageHeader, Breadcrumb, Divider, Row, Col } from "antd";
import { Content } from "antd/lib/layout/layout";
import { Link } from "react-router-dom";
import { TabletFilled } from "@ant-design/icons";
import history from "../../../history";
import {
  renderCheckbox,
  renderInput,
  renderSelect,
  renderTextField,
} from "../../../component/form/form";
import { connect } from "react-redux";
import { createNewRole, getRoleById, updateRole } from "../../../actions/role";

const tailLayout = {
  wrapperCol: { offset: 4, span: 16 },
};
const auth = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

const EditRole = ({ getRoleById, updateRole, location }) => {
  const [data, setData] = useState(null);
  const [roleId, setRoleId] = useState(null);

  const onFinish = (values) => {
    updateRole(values, roleId);
  };

  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
  };
  const [form] = Form.useForm();

  useEffect(async () => {
    const search = location.search;
    const id = new URLSearchParams(search).get("id");
    setRoleId(id);
    const res = await getRoleById(id);
    setData(res);
    form.setFieldsValue({
      role: res?.name,
      active: res?.active,
      user_management: res?.access?.user_management,
      client_management: res?.access?.client_management,
      support_management: res?.access?.support_management,
      app_management: res?.access?.app_management,
      finance_management: res?.access?.finance_management,
      // message_management : res?.access?.message_management,
      message_management: false,
      setting_management: res?.access?.setting_management,
      code_management: res?.access?.code_management,
      report_management: res?.access?.report_management,
      product_management: res?.access?.product_management,

      // mobile_number: res?.mobile_number,
    });
  }, []);
  return (
    <Content>
      <Breadcrumb style={{ padding: "10px 0px" }}>
        <Breadcrumb.Item>
          <Link to="/dashboard">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Update Role</Breadcrumb.Item>
      </Breadcrumb>
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="Edit Role"
        subTitle="Role Management"
        extra={[
          <Button
            key="1"
            type="primary"
            icon={<TabletFilled />}
            onClick={() => history.push("/roles")}
          >
            Role List
          </Button>,
        ]}
      ></PageHeader>
      <br />

      {data ? (
        <Form
          name="basic"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ alignSelf: "center" }}
          requiredMark={false}
          form={form}
        >
          {renderInput("role", "Role Name", [
            { required: true, message: "Role name is required" },
          ])}
          <Divider orientation="center">Assign role's access</Divider>

          <Row>
            <Col flex="1 1 200px">
              {renderCheckbox("user_management", "User Management", [
                { required: false },
              ])}
              {renderCheckbox("client_management", "Client Management", [
                { required: false },
              ])}
              {renderCheckbox("app_management", "App Management", [
                { required: false },
              ])}
              {renderCheckbox("code_management", "Code Management", [
                { required: false },
              ])}
              {renderCheckbox("report_management", "Report Management", [
                { required: false },
              ])}
            </Col>
            <Col flex="1 1 200px">
              {renderCheckbox("finance_management", "Finance Management", [
                { required: false },
              ])}
              
              {renderCheckbox("support_management", "Support Management", [
                { required: false },
              ])}
              {renderCheckbox("product_management", "Product Management", [
                { required: false },
              ])}
              {renderCheckbox("setting_management", "Setting Management", [
                { required: false },
              ])}
            </Col>
          </Row>
          {renderSelect(
            "active",
            "Auth",
            [{ required: true }],
            "Select a option and change input text above",
            auth,
            "none"
          )}
          {renderTextField("remark", "Remark", [
            { required: true, message: "Remark is required" },
          ])}

          <Form.Item {...tailLayout}>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      ) : null}
    </Content>
  );
};



export default connect(null, { createNewRole, getRoleById, updateRole })(
  EditRole
);
